import { Card, CardContent, CardHeader } from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import AlertRecipientSettingForm from '@views/Alerts/Common/AlertRecipientSettingForm';

import { AlertRecipientType } from 'generated/types';

const messages = defineMessages({
  'alert.title': {
    id: 'organization.setting.menu.alertSetting',
    defaultMessage: 'Alert Settings',
  },
  'alert.subtitle': {
    id: 'organization.setting.alert.subtitle',
    defaultMessage: 'Manage your organization settings for alerts',
  },
  instructions: {
    id: 'alertRecipientSettingForm.instructions.default',
    defaultMessage:
      "Select your {isOrg, select, true{organization's} other{}} out-of-parameter alert delivery method below. You can enable email, sms, or both. Alerts are created within a patient's alert section and, when triggered, will be sent to the destination(s) you have turned on here:",
  },
});

interface AlertSettingsProps {
  /** Organization account ID */
  account_id: string;
}

export default function AlertSettings({ account_id }: AlertSettingsProps) {
  const { formatMessage } = useIntl();

  return (
    <Card>
      <CardHeader
        subheader={formatMessage(messages['alert.subtitle'])}
        title={formatMessage(messages['alert.title'])}
      />
      <CardContent>
        <AlertRecipientSettingForm
          id={account_id}
          overridingText={{
            instructions: formatMessage(messages.instructions, {
              isOrg: true,
            }),
          }}
          type={AlertRecipientType.account}
        />
      </CardContent>
    </Card>
  );
}
